/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Draw_In_OrderInputs */

const en_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, in call order`)
};

const zh_hans1_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`，按调用顺序`)
};

const pt_br2_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, na ordem de chamada`)
};

const es_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, en orden de llamada`)
};

const fr_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, dans l’ordre des appels`)
};

const de_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, in Aufrufreihenfolge`)
};

const ru_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, в порядке вызова`)
};

const it_endpoint_draw_in_order = /** @type {(inputs: Endpoint_Draw_In_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, in ordine di chiamata`)
};

/**
* | output |
* | --- |
* | ", in call order" |
*
* @param {Endpoint_Draw_In_OrderInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_draw_in_order = /** @type {((inputs?: Endpoint_Draw_In_OrderInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Draw_In_OrderInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_draw_in_order(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_draw_in_order(inputs)
	if (locale === "es") return es_endpoint_draw_in_order(inputs)
	if (locale === "fr") return fr_endpoint_draw_in_order(inputs)
	if (locale === "de") return de_endpoint_draw_in_order(inputs)
	if (locale === "ru") return ru_endpoint_draw_in_order(inputs)
	if (locale === "it") return it_endpoint_draw_in_order(inputs)
	return en_endpoint_draw_in_order(inputs)
});